import React, { useState } from 'react'
import ReactGA from 'react-ga'
import { isMobile } from 'react-device-detect'
import { groupBy } from 'lodash'
import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Grid,
  Link,
  Typography,
} from '@material-ui/core'
import {
  Email as EmailIcon,
  ExpandMore as ExpandMoreIcon,
  Facebook as FacebookIcon,
  Instagram as InstagramIcon,
  LocalPhone as PhoneIcon,
  Place as PlaceIcon,
  Public as WebsiteIcon,
  Share as ShareIcon,
  Twitter as TwitterIcon,
  WhatsApp as WhatsAppIcon,
} from '@material-ui/icons'
import { getFormattedEndereco } from '../utils/estabelecimentos'
import IconWithLabel from './general/IconWithLabel'
import ActionIcon from './general/ActionIcon'
import { withStyles } from '@material-ui/core'
import { styles } from '../styles/js/dialogEstabelecimento'

const DialogEstabelecimentoComponent = ({
  classes,
  dialog,
  reportEstabelecimento,
  pageProps,
}) => {
  const [expandedPanel, setExpandedPanel] = useState(false)

  const renderEndereco = (endereco) => {
    return (
      <Grid className={classes.directions} container key={endereco.id}>
        {(endereco.cidade || endereco.bairro || endereco.endereco) && (
          <>
            <Typography variant='h5' className={classes.cardAdress}>
              {getFormattedEndereco(endereco)}
            </Typography>
            <Typography paragraph>
              <Link
                target='_blank'
                rel='noopener noreferrer'
                href={`https://www.google.com/maps?q=${getFormattedEndereco(
                  endereco
                ).trim()}`}
              >
                Como chegar
              </Link>
            </Typography>
          </>
        )}

        {endereco && endereco.telefone && (
          <IconWithLabel Icon={PhoneIcon} value={endereco.telefone} />
        )}
      </Grid>
    )
  }

  const renderEnderecos = (enderecos) => {
    if (enderecos.length <= 3) {
      return enderecos.map((endereco) => renderEndereco(endereco))
    } else {
      return (
        <Grid container style={{ marginBottom: 24 }}>
          {Object.keys(groupBy(enderecos, 'cidade')).map((cidade) => (
            <ExpansionPanel
              key={cidade}
              expanded={expandedPanel === cidade}
              onChange={(event, isExpanded) =>
                setExpandedPanel(isExpanded ? cidade : false)
              }
            >
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls='panel'
                id={`panel-${cidade}`}
              >
                <Typography className={classes.expansionPanelTitle}>
                  {cidade}
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <Grid container>
                  {groupBy(enderecos, 'cidade')[cidade].map((endereco) => (
                    <Grid item xs={12}>
                      {renderEndereco(endereco)}
                    </Grid>
                  ))}
                </Grid>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          ))}
        </Grid>
      )
    }
  }
  return (
    <>
      {dialog.data && (
        <Grid
          container
          justify='space-between'
          className={classes.socialSection}
        >
          <Grid item xs={12}>
            {renderEnderecos(dialog.data.enderecos)}

            {dialog.data.email && (
              <IconWithLabel Icon={EmailIcon} value={dialog.data.email} />
            )}

            {dialog.data.whatsapp && (
              <IconWithLabel
                Icon={WhatsAppIcon}
                value={dialog.data.whatsapp}
                href={`https://api.whatsapp.com/send?phone=55${dialog.data.whatsapp.replace(
                  /\D/g,
                  ''
                )}`}
              />
            )}

            {dialog.data.facebook && (
              <IconWithLabel
                Icon={FacebookIcon}
                value={dialog.data.facebook}
                href={
                  dialog.data.facebook.substring(0, 4) === 'http'
                    ? `${dialog.data.facebook}`
                    : `https://facebook.com/${dialog.data.facebook.replace(
                        ' ',
                        ''
                      )}`
                }
              />
            )}

            {dialog.data.instagram && (
              <IconWithLabel
                Icon={InstagramIcon}
                value={dialog.data.instagram}
                href={
                  dialog.data.instagram.substring(0, 4) === 'http'
                    ? `${dialog.data.instagram
                        .replace('@', '')
                        .replace(' ', '')}`
                    : `https://instagram.com/${dialog.data.instagram
                        .replace('@', '')
                        .replace(' ', '')}`
                }
              />
            )}

            {dialog.data.site && (
              <IconWithLabel
                Icon={WebsiteIcon}
                value={dialog.data.site}
                href={
                  dialog.data.site.substring(0, 4) === 'http'
                    ? `${dialog.data.site.replace(' ', '')}`
                    : `https://${dialog.data.site.replace(' ', '')}`
                }
              />
            )}
          </Grid>

          <Grid item xs={12}>
            {navigator.userAgent.split('/')[0] === 'Você na RPC' ? (
              <Typography
                variant='h5'
                style={{ textAlign: 'center', marginTop: 24 }}
              >
                Compartilhe este estabelecimento usando o botão{' '}
                <ShareIcon fontSize='small' className={classes.shareIcon} /> no
                canto superior direito
              </Typography>
            ) : (
              <Grid container justify='space-around'>
                <Grid item xs={12}>
                  <Typography variant='h5' className={classes.shareSocial}>
                    Compartilhe{' '}
                    <span className={classes.primary}>{dialog.data.nome}</span>{' '}
                    nas redes sociais:
                  </Typography>
                </Grid>
                <Grid item>
                  <ActionIcon
                    Icon={WhatsAppIcon}
                    fontSize={48}
                    label={'WhatsApp'}
                    website={`${
                      isMobile ? 'whatsapp://' : 'https://web.whatsapp.com/'
                    }send?text=${pageProps.shareMessage.replace(
                      '{0}',
                      dialog.data.nome.replace(/\s{2,}/g, ' ').trim()
                    )}%0a${window.location.href}`}
                    onClickAction={() =>
                      ReactGA.event({
                        category: `${pageProps.title}`,
                        action: 'Share via WhatsApp',
                      })
                    }
                  />
                </Grid>

                <Grid item>
                  <ActionIcon
                    Icon={FacebookIcon}
                    fontSize={48}
                    label={'Facebook'}
                    website={`https://www.facebook.com/sharer/sharer.php?&u=${
                      window.location.href
                    }&quote=${pageProps.shareMessage.replace(
                      '{0}',
                      dialog.data.nome.replace(/\s{2,}/g, ' ').trim()
                    )}`}
                    onClickAction={() =>
                      ReactGA.event({
                        category: `${pageProps.title}`,
                        action: 'Share via Facebook',
                      })
                    }
                  />
                </Grid>

                <Grid item>
                  <ActionIcon
                    Icon={TwitterIcon}
                    fontSize={48}
                    label={'Twitter'}
                    website={`http://twitter.com/share?text=${pageProps.shareMessageTwitter.replace(
                      '{0}',
                      dialog.data.nome.replace(/\s{2,}/g, ' ').trim()
                    )}&url=${window.location.href}&hashtags=${
                      pageProps.hashtag
                    },RPC`}
                    onClickAction={() =>
                      ReactGA.event({
                        category: `${pageProps.title}`,
                        action: 'Share via Twitter',
                      })
                    }
                  />
                </Grid>
              </Grid>
            )}
          </Grid>

          <Grid item xs={12}>
            <Grid container justify='center'>
              <Typography
                variant='subtitle2'
                className={classes.inappropriateContent}
              >
                Ops! Este estabelecimento deveria estar fechado neste momento?{' '}
                <Link
                  href={'#'}
                  className={classes.inappropriateContentLink}
                  onClick={reportEstabelecimento}
                >
                  Avise a gente!
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  )
}

export default withStyles(styles)(DialogEstabelecimentoComponent)
